module.exports = __webpack_public_path__ + "img/CuCiGlass04.4ccac30f.png";